export default __webpack_public_path__ + "static/survey-light-mode-38fa170a1f2555da940fb80db748b127.png";